/**
 * @description: ad-素材尺寸卡片组
 */
import AdMaterialSizeCard from './index';

import './index.scss';

type IAdMaterialSizeCardGroupData = {
  /**
   * value值
   */
  value: string | number

  /**
   * sizeName值
   */
  sizeName: string

  [key: string]: any
}
export interface IAdMaterialSizeCardGroup {
  /**
   * data数据
   */
  data?: Array<IAdMaterialSizeCardGroupData>

  /**
   * 选中的值
   */
  value?: Array<number | string>

  /**
   * change回调
   */
  onChange?: (value: Array<number | string>) => void
  /**
   * 多选
   */
  multiple?: boolean
}
const AdMaterialSizeCardGroup = (props: IAdMaterialSizeCardGroup) => {
  const { data = [], value = [], onChange, multiple = false } = props;

  return (
    <div className="odc-ad-material-size-card-group">
      {data?.map((item, index) => (
        <AdMaterialSizeCard
          key={`ODCAdMaterialSizeCard_${index}`}
          sizeName={item.sizeName}
          isChecked={value?.includes(item.value)}
          isMultiple={multiple}
          onClick={() => {
            let resultValue = value;
            if (multiple) {
              if (resultValue?.includes(item.value)) {
                resultValue = resultValue.filter((v) => v !== item.value);
              } else {
                resultValue = [...resultValue, item.value];
              }
            }
            else {
              resultValue = [item.value];
            }
            onChange?.(resultValue);
          }}
        />
      ))}
    </div>
  );
};
export default AdMaterialSizeCardGroup;